export default __webpack_public_path__ + "static/media/upload.adc8f894.svg";